export enum Entity {
  Title = 'title',
  Date = 'date',
  Total = 'total',
}
